<h2 mat-dialog-title transloco="MERGE_SUCCESSFUL"></h2>
<mat-dialog-content>
  <p>{{ 'DELETE_MERGED_DOCUMENTS_DIALOG_MESSAGE' | transloco }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onClickOpenDocument()">
    <mat-icon>open_in_new</mat-icon>
    <span transloco="OPEN"></span>
  </button>
  <span class="spacer"></span>
  <button mat-button (click)="onClickDelete()">
    <span transloco="DELETE"></span>
  </button>
  <button mat-button (click)="onClickClose()" cdkFocusInitial>
    <span transloco="CLOSE"></span>
  </button>
</mat-dialog-actions>
